import { ReactNode } from 'react';

const Filters = ({ children }: { children: ReactNode }) => {
  return <div style={{ padding: '24px 32px' }}>{children}</div>;
};

export default Filters;
